import { useState } from 'react'
import {ModalBase} from '../ModalBase'

import WhiteRight from '../../../media/felsv/white_right-arrow_icon.svg'
import DarkLeft from '../../../media/felsv/dark_left-arrow_icon.svg'

import { emailInvoice, validateSend, validateSendOnBlur } from '../../../utils/invoice/validateSendInvoice'
import InputChips from '../../../pages/OtrosDocumentos/Components/InputChips'
import { unirChipsJoin } from '../../../utils/strings.utils'

const ModalEnviarEmail = (props: any) => {
  const [chipsEmails, setChipsEmails] = useState(props.chipsEmail)
  const [formEnvio, setFormEnvio] = useState<emailInvoice>({email: props?.defaultEmail ?? ""});
  const [errors, setErrors] = useState<emailInvoice>({email: ''});

  const handleInputChange = (e: any) => {
    setFormEnvio({
      ...formEnvio,
      [e.target.name]: e.target.value,
    })
  }

  const handleErrors = (e: any) => {
    setErrors(
      validateSendOnBlur({...formEnvio, [e.target.name]: e.target.value}, e.target.name, errors, chipsEmails)
    )
  }

  const handleClickSend = (e: any) => {
    e.preventDefault();
    const err = validateSend(formEnvio, chipsEmails);

    if (Object.keys(err).length > 0) {
      // Hay error
      setErrors({
        email: err?.email,
      })
    } else {
      // No hay error
      setErrors({
        email: '',
      })
    }

    if (
      err.email
    ) return

    props.onSendEmail({email: unirChipsJoin(chipsEmails, formEnvio.email)});
  }

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '550px'}}>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <form className='form-content'  onSubmit={handleClickSend}>
            <div className='w-layout-hflex'>
              <h3 className='card-title l'>Enviar por correo electrónico</h3>
            </div>
            <div className='form-separator'></div>
            <InputChips 
              maxChips={5} chips={chipsEmails} setChips={setChipsEmails} maxLength={50} 
              required name='email' placeholder='Correo electrónico' label='Correo electrónico' type='text'
              onChange={handleInputChange} onBlur={handleErrors} value={formEnvio.email}
              error={errors.email}
            />
            <div className='form-separator'></div>
            <div className='w-layout-hflex button-actions'>
              {
                props.showBackBtn && 
                (
                  <button type='button' className='m button transparent w-inline-block' onClick={props.onBackBtn}>
                    <img src={DarkLeft} alt='Regresar' />
                    <div>Regresar</div>
                  </button>
                )
              }
              {
                props.showCancelBtn && 
                (
                  <button type='button' className='m button transparent w-inline-block' onClick={props.onCancelBtn}>
                    <div>Cancelar</div>
                  </button>
                )
              }
              <button type='submit' className='m button w-inline-block'>
                <div>Enviar</div>
                <img src={WhiteRight} alt='Enviar correo' />
              </button>
            </div>
          </form>          
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalEnviarEmail
